module.exports = __webpack_public_path__ + "static/media/signature.f2d77263.svg";